var transitionFadeInFromTop = function transitionFadeInFromTop(options) {
  var transitionDelay = options.transitionDelay,
    transitionDuration = options.transitionDuration,
    transitionStatus = options.transitionStatus;
  switch (transitionStatus) {
    case 'entered':
      {
        return {
          opacity: 1,
          top: 0
        };
      }
    case 'entering':
      {
        return {
          opacity: 1,
          top: 0,
          transition: "opacity ".concat(transitionDuration, "ms ease-in ").concat(transitionDelay, "ms, top ").concat(transitionDuration, "ms ease-in ").concat(transitionDelay, "ms")
        };
      }
    case 'exited':
      {
        return {
          opacity: 0,
          top: '-100%'
        };
      }
    case 'exiting':
      {
        return {
          opacity: 0,
          transition: "opacity ".concat(transitionDuration, "ms ease-in ").concat(transitionDelay, "ms, top ").concat(transitionDuration, "ms ease-in ").concat(transitionDelay, "ms"),
          top: '-100%'
        };
      }
    default:
      {
        // unmounted
        return {
          opacity: 0,
          top: '-100%'
        };
      }
  }
};
export { transitionFadeInFromTop };